import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getGstList } from 'components/gst/GstAPI';
import { setGstList, setGstDashboardGstList } from 'store/slice/PharmaSlice';
import GstDashboard from '../GstDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function GstPageImpl() {
    const dispatch = useDispatch();
    const { gstList} = useSelector((state)=>state.pharmaslice);
    
    const getGstListSuccess = (list) =>{dispatch(setGstList(list));}
    useEffect(() => {
        getGstList(()=>{}, getGstListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setGstDashboardGstList( gstList));
    },[ gstList])

    return (
        < GstDashboard />
    )

}